export const toTableRowItems = (items: any[]) =>
  items.map((item: any) => ({
    supplierCode: item.supplierCode || '',
    supplierName: item.supplierName || '',
    parentSociety: item.parentSociety || '',
    shopCode: item.shopCode || '',
    supportCode: item.supportCode || '',
    stock: item.stock || '',
    lastUpdate: item.lastUpdate || '',
    lastUpdateBy: item.lastUpdateBy || '',
    dsUpdateSupportStockType: item.dsUpdateSupportStockType || '',
    dsUpdateSupportStockTypeValue: item.dsUpdateSupportStockTypeValue || ''
  }))
